import React, { Component } from "react";
import "./CustomHeroCard.css";

export default class CustomHeroCardButtonRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
    };
  }

  handleMouseEnter = () => {
    this.setState({ hover: true });
  };
  handleMouseLeave = () => {
    this.setState({ hover: false });
  };

  render() { 
    return (
      <div
        className="herocard-button herocard-button-row"
        key={this.props.btn.title}       
        style={{
          backgroundColor: this.props.botSettings.colours.heroButtonBackground,
          color:this.props.botSettings.colours.heroButtonText,
          ...(this.state.hover && { backgroundColor: this.props.botSettings.colours.heroButtonBackgroundHover, color:this.props.botSettings.colours.heroButtonTextHover }),
        }}
        onMouseEnter={this.handleMouseEnter} // Or onMouseOver
        onMouseLeave={this.handleMouseLeave}
        onClick={() => {
          this.props.action(this.props.btn);
        }}
      >
        {this.props.btn.title}
      </div>
    );
  }
}
